import { render, staticRenderFns } from "./GroupMembershipAvailableTable.vue?vue&type=template&id=339a7d10&scoped=true&"
import script from "./GroupMembershipAvailableTable.vue?vue&type=script&lang=js&"
export * from "./GroupMembershipAvailableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339a7d10",
  null
  
)

export default component.exports